/**
 * AQUAS Header - Sticky scroll behavior
 * Adds/removes 'scrolled' class based on scroll position
 */

class AquasHeader {
  constructor() {
    this.container = document.querySelector('.aquas-sticky-container');
    if (!this.container) return;

    this.scrollThreshold = 100;
    this.lastScrollTop = 0;
    this.stickyType = this.container.dataset.sticky;

    this.init();
  }

  init() {
    if (this.stickyType === 'none') return;

    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });

    // Check initial state
    this.handleScroll();
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.stickyType === 'always') {
      // Always sticky, just add scrolled class for size reduction
      if (scrollTop > this.scrollThreshold) {
        this.container.classList.add('scrolled');
      } else {
        this.container.classList.remove('scrolled');
      }
    } else if (this.stickyType === 'compact') {
      // Compact sticky header - shows simplified header when scrolling
      if (scrollTop > this.scrollThreshold) {
        this.container.classList.add('compact');
      } else {
        this.container.classList.remove('compact');
      }
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new AquasHeader());
} else {
  new AquasHeader();
}
